// extracted by mini-css-extract-plugin
export default {"nav_wrap":"styles_nav_wrap__lTpgk","nav_list":"styles_nav_list__1CL-H","nav_item":"styles_nav_item__GjuW1","nav_link":"styles_nav_link__iHoB3"};